import { Component, OnInit, OnDestroy } from '@angular/core';
import { ModelRestService } from '../../model-rest.service';
import { IntervalObservable } from "rxjs/observable/IntervalObservable";
/** consulta el status del servicio
*/
@Component({
  selector: 'rch-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css']
})
export class StatusComponent implements OnInit,OnDestroy {

  constructor(private model:ModelRestService) { }
/** Inicializa el servicio en true  */
  public status_ok:boolean = true;
  private alive:boolean = true;
  /** checa estatus y muestra el mensaje del servicio  */
  ngOnInit() {
    
  }
  ngOnDestroy(){
    this.alive = false; // switches your IntervalObservable off
  }

}
